import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor
} from '@angular/common/http';
import { catchError } from 'rxjs';
import { HandleErrorService } from '../services/handle-error.service';

@Injectable()
export class GlobalHttpErrorHandlerInterceptor implements HttpInterceptor {

  constructor(
    private handleErrorService: HandleErrorService,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): any {
    if (request.headers.has("x-intercept-error")) {
      return next
        .handle(request)
        .pipe(catchError(this.handleErrorService.handleError(`${request.url}`)))
    }
    return next.handle(request)
  }
}
